import { useCallback, useMemo } from 'react';

import { ServiceTypeEnum } from 'src/common/external/bambi-api/bambiApi';
import { ItemSelector } from 'src/common/ItemSelector/ItemSelector';
import { serviceTypes } from 'src/common/serviceTypes';

export function ServiceTypeFilter({
  selectedServiceTypeIds,
  onServiceTypeChange,
}: {
  selectedServiceTypeIds: ServiceTypeEnum[];
  onServiceTypeChange: (serviceTypes: ServiceTypeEnum[]) => void;
}) {
  const selectedServiceTypesItems = useMemo(() => {
    return selectedServiceTypeIds.map((serviceType) => ({
      id: serviceType,
      label: serviceType,
    }));
  }, [selectedServiceTypeIds]);

  const handleServiceTypeChange = useCallback(
    (serviceTypes: { id: ServiceTypeEnum; label: string }[]) => {
      onServiceTypeChange(serviceTypes.map((serviceType) => serviceType.id));
    },
    [onServiceTypeChange]
  );

  return (
    <ItemSelector
      items={serviceTypes.map((serviceType) => ({
        id: serviceType,
        label: serviceType,
      }))}
      selectedItems={selectedServiceTypesItems}
      onSelectionChange={handleServiceTypeChange}
      getItemLabel={(serviceType) => serviceType.label}
      dataTestId="service-type-filter-search"
      noItemsText="No service types found."
    />
  );
}
